import React, { useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableCell,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  ModalDeleteConfirm,
  Title,
  Loading,
  TableCellDefault,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import {
  useDatatablesServerSide,
  useDatatables,
} from "App/hooks";
import {
  deletePoById,
  getByFilterPO,
  headCells,
  RenderStatusPoBadge,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import { DownloadIcon, PencilIcon, TrashIcon } from "App/Assets";
import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
} from "App/utils/helpers";

import {
  BASE_URL_4,
  instance4,
  WMS_FA_PO,
} from "App/constants";
import FormFilterDaftarPO from "./FormFilterDaftarPO";
import { STATUS_TRANSAKSI_DRAFT } from "../PurchaseOrder/helpers";
import fileDownload from "js-file-download";
import { FreezeTable } from "components/organism";

export default function DaftarPo({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [poID, setPoId] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const handleClickUpdate = async (row) => {
    Promise.resolve()
      .then(() => {
        changeMenu(WMS_FA_PO);
      })
      .then(() => {
        changeParentData({
          idreq: row?.id_request,
          idpo: row?.id,
          nomorPo: row?.nomorPO,
          date: defaultDateInputDisplay(row?.date, true),
          // gudang_id: row?.gudang_id,
          // gudang: row?.gudang,
          supplier_id: row?.supplier_id,
          supplier: row?.supiler,
          produsen_id: row?.produsen_id,
          produsen: row?.produsen,
          unit_id: row?.unit_id,
          unit: row?.unit,
          penerima: row?.penerima,
          remark: row?.remark,
          type: "update",
          status: row?.status,
          isOpenDraf: true,
          isProcess: row?.status_transaksi === 0 ? false : true,
          jumlah: 0,
          tax: row?.tax === null ? 0 : row?.tax,
          total_jumlah: 0,
          status_transaksi: row?.status_transaksi,
          isRequest: isNull(row?.id_request) ? false : true,
        });
        changeTitle(WMS_FA_PO);
        handleClickMenu({
          code: WMS_FA_PO,
          name: "PO",
        });
      });
  };

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(
    RESET_STATE_FORM_FILTER
  );
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterPO(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleClickDelete = (row) => {
    setPoId(row?.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deletePoById(poID);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  function strReplace(str) {
    var newStr = "";
    for (var i = 0; i < str.length; i++) {
      if (str[i] === "/") {
        newStr += "_";
      } else {
        newStr += str[i];
      }
    }
    return newStr;
  }

  const downloadPDF = async (id, name) => {
    setLoading(true);
    const filename = strReplace(name);
    try {
      const api = await instance4.get(
        `${BASE_URL_4}/wmsAsset/po/download_pdf/${id}`,
        {
          responseType: "blob",
        }
      );
      fileDownload(api.data, filename + ".pdf");
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
    setLoading(false);
  };

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar PO Fixed Asset"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}
        >
          <FormFilterDaftarPO
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <TableDaftarPO
            rows={rows}
            classes={classes}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
            downloadPDF={downloadPDF}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}

const TableDaftarPO = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  downloadPDF,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow
            hover
            tabIndex={-1}
            key={index}
            // style={{
            //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
            // }}
          >
            <TableCell scope="row" padding="none" align="center">
              {index + 1}
            </TableCell>

            <TableCell scope="row" padding="none" align="center">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "7px",
                }}
              >
                <IconButtonDatatable
                  onClick={() => downloadPDF(row.id, row?.nomorPO)}
                >
                  <DownloadIcon />
                </IconButtonDatatable>
                <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
                  <PencilIcon />
                </IconButtonDatatable>

                {row.status_transaksi === STATUS_TRANSAKSI_DRAFT && (
                  <IconButtonDatatable onClick={() => handleClickDelete(row)}>
                    <TrashIcon />
                  </IconButtonDatatable>
                )}
              </div>
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">
              {isNull(row?.pembelian_id) ? "-" : row?.pembelian_id}
            </TableCell>
            <TableCell align="left">{row?.nomorPO}</TableCell>
            <TableCell align="left">{defaultDateDisplay(row?.date)}</TableCell>
            <TableCell align="left">
              {isNull(row?.unit) ? "-" : row?.unit}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.produsen) ? "-" : row?.produsen}
            </TableCell>
            <TableCell align="left">
              {isNull(row?.supiler) ? "-" : row?.supiler}
            </TableCell>
            <TableCell align="left">
              <RenderStatusPoBadge status={row.status_transaksi} />
            </TableCell>
            <TableCell align="left">{row?.processedBy}</TableCell>
            <TableCell align="right">
              {row.total_harga === null ? "0" : formatNumber(row.total_harga)}
            </TableCell>
            <TableCell align="left">{row?.penerima}</TableCell>
            <TableCellDefault row={row} type={'custom'}/>
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};
